import type { FC } from 'react';
import classNames from 'classnames';

import WinnerIcon from 'app/icons/arrow_team-winner.svg';

import style from './style.module.scss';

interface Props {
  direction: 'left' | 'right';
  number?: number;
}

const StatWinnerArrow: FC<Props> = ({ direction, number = 1 }) => (
  <div className={classNames(style.statWinnerArrows, { [style.right]: direction === 'right' })}>
    {Array(number)
      .fill(null)
      .map((_, index) => (
        <WinnerIcon key={index} />
      ))}
  </div>
);

StatWinnerArrow.displayName = 'StatWinnerArrow';

export default StatWinnerArrow;
